module.exports = __webpack_public_path__ + "img/tree-04-f-leaves.f885014b.png";